'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002e$002dIterable$0024 from "./scala.collection.-Iterable$.js";
import * as $j_scala$002ecollection$002eimmutable$002e$002dIndexed$002dSeq$0024 from "./scala.collection.immutable.-Indexed-Seq$.js";
import * as $j_scala$002emath$002e$002dBig$002dInt from "./scala.math.-Big-Int.js";
import * as $j_scala$002emath$002e$002dEquiv$0024 from "./scala.math.-Equiv$.js";
import * as $j_scala$002eutil$002e$002dLeft$0024 from "./scala.util.-Left$.js";
import * as $j_scala$002eutil$002e$002dRight$0024 from "./scala.util.-Right$.js";
var $p;
/** @constructor */
function $c_s_package$() {
  this.Rq = null;
  this.Rw = null;
  this.Rs = null;
  this.Rt = null;
  this.Nu = null;
  this.Nv = false;
  this.Ru = null;
  this.Rr = null;
  this.Rv = null;
  $n_s_package$ = this;
  $j_scala$002ecollection$002e$002dIterable$0024.$m_sc_Iterable$();
  this.Rq = $j_scala$002ecollection$002e$002dIterable$0024.$m_sc_Iterable$();
  this.Rw = $j_java$002elang$002e$002dObject.$m_sci_Seq$();
  $j_scala$002ecollection$002eimmutable$002e$002dIndexed$002dSeq$0024.$m_sci_IndexedSeq$();
  this.Rs = $j_java$002elang$002e$002dObject.$m_sci_List$();
  this.Rt = $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  $j_java$002elang$002e$002dObject.$m_sci_LazyList$();
  $j_java$002elang$002e$002dObject.$m_sci_Vector$();
  $j_scala$002emath$002e$002dEquiv$0024.$m_s_math_Equiv$();
  this.Ru = $j_java$002elang$002e$002dObject.$m_s_math_Ordering$();
  this.Rr = $j_scala$002eutil$002e$002dLeft$0024.$m_s_util_Left$();
  this.Rv = $j_scala$002eutil$002e$002dRight$0024.$m_s_util_Right$();
}
export { $c_s_package$ as $c_s_package$ };
$p = $c_s_package$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
}
export { $h_s_package$ as $h_s_package$ };
$h_s_package$.prototype = $p;
$p.jh = (function() {
  if ((!this.Nv)) {
    this.Nu = $j_scala$002emath$002e$002dBig$002dInt.$m_s_math_BigInt$();
    this.Nv = true;
  }
  return this.Nu;
});
var $d_s_package$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_package$, "scala.package$", ({
  v9: 1
}));
export { $d_s_package$ as $d_s_package$ };
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$();
  }
  return $n_s_package$;
}
export { $m_s_package$ as $m_s_package$ };
